import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>CodeAlignR</h3>
            <p>AI solutions that solve real business problems. Voice agents and chatbots that work for you.</p>
          </div>
          {/* <div className="footer-section">
            <h4>Services</h4>
            <ul>
              <li><a href="#services">AI Voice Agents</a></li>
              <li><a href="#services">AI Chatbots</a></li>
            </ul>
          </div> */}
          <div className="footer-section">
            <h4>Contact</h4>
            <ul>
              <li><a href="#contact">Get Consultation</a></li>
              <li><a href="mailto:contact@codealignr.com">contact@codealignr.com</a></li>
            </ul>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2026 CodeAlignR. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
